import React from "react";
import SCreateCategory from "./CreateCategory";
import SCategoriesTable from "./CategoriesTable";

const SMainCategories = () => {
  return (
    <section className="content-main">
      <div className="content-header">
        <h2 className="content-title">Categories</h2>
      </div>

      <div className="card shadow-sm">
        <div className="card-body">
          <div className="row">
            {/* Create category */}
            <SCreateCategory />
            {/* Categories table */}
            <SCategoriesTable />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SMainCategories;
